import {useReducer} from 'react'
import DigitButton  from './DigitButton'
import OperationButton  from './OperationtButton'

import './styles.css'
export const ACTIONS = {
  ADD_DIGIT:"add-digit",
  CHOOES_OPERATION:"choose-operation",
  CLEAR:"clear",
  DELETE_DIGIT:"delete-digit",
  EVALUATE:"evaluate"
}
function reducer(state,{type,payload}){
  switch( type ){
    case ACTIONS.ADD_DIGIT:
      if (state.overwrite){
        return {
          ...state,
          currentOperand:payload.digit,
          overwrite:false
        }
      }
      if (payload.digit === "0"&& state.currentOperand === "0"){
        return state
      }
      if(payload.digit === "."){
        return {
        ...state,
        currentOperand: `${payload.digit}` 
        }
      }
      return {
      ...state,
      currentOperand:`${state.currentOperand||""}${payload.digit}` ,  
    }
    case ACTIONS.CHOOES_OPERATION:
      if(state.previousOperand == null && state.currentOperand == null){
        return state
      }
      if (state.previousOperand == null){
        return {
          ...state,
          operation:payload.operation,
          previousOperand:state.currentOperand,
          currentOperand:null
        }
      }
      return {
        ...state,
        previousOperand:evaluate(state),
        operation:payload.operation,
        currentOperand:null
   }
    case ACTIONS.CLEAR:
      return {}
    case ACTIONS.EVALUATE:
        if (
          state.previousOperand == null ||
          state.currentOperand == null ||
          state.operation == null
        ) {
      return state
        }
      return{
          ...state,
          overwrite:true,
          previousOperand:null,
          operation:null,
          currentOperand:evaluate(state),
   }
    case ACTIONS.DELETE_DIGIT:
          if (state.overwrite){
        return {
          ...state,
          overwrite:false,
          currentOperand:null,
            }
          }
            if (state.currentOperand === null){
              return state
            }
            if (state.currentOperand.length === 1){
              return {
                ...state,
                currentOperand:null
              }
            }
            return {
              ...state,
              currentOperand:state.currentOperand.slice(0,-1)        
                  }
   }
}

function evaluate({currentOperand,previousOperand,operation}){
  const pre = parseFloat(previousOperand)
  const cur = parseFloat(currentOperand)
  if (isNaN(pre) || isNaN(cur))return ""
  let computed
  switch(operation){
    case "+":
      computed = pre + cur
      break
    case "-":
      computed = pre - cur
      break
    case "*":
      computed = pre * cur  
      break
    case "÷":
      computed = pre / cur
      break
  }
  return computed.toString()
}

const INTERGER_FORMATTER = new Intl.NumberFormat("en-US",{
maximumFractionDigits:0,
})
function formatOperand(operand){
  if (operand == null||operand== undefined) return 
  const [integer,decimal]=operand.split(".")
  if (decimal == null) return   INTERGER_FORMATTER.format(integer)
}


function App() {
  const [{currentOperand,previousOperand ,operation},dispatch] = useReducer(reducer,{})
  return (
    <div className="calculater-grid">
      <div className="output">
        <div className="previous-operand">
          {formatOperand(previousOperand)}  {operation}
          </div>
        <div className="current-operand">
          {formatOperand(currentOperand)}
          </div>
      </div>
      <button className= "span-two"
      onClick={()=>dispatch({type:ACTIONS.CLEAR})}
      >
        AC</button>
      <button 
            onClick={()=>dispatch({type:ACTIONS.DELETE_DIGIT})}

      >DEL</button>
      <OperationButton operation="÷" dispatch={dispatch}/>
      <DigitButton digit="1" dispatch={dispatch}/>
      <DigitButton digit="2" dispatch={dispatch}/>
      <DigitButton digit="3" dispatch={dispatch}/>
      <OperationButton operation="*" dispatch={dispatch}/>
      <DigitButton digit="4" dispatch={dispatch}/>
      <DigitButton digit="5" dispatch={dispatch}/>
      <DigitButton digit="6" dispatch={dispatch}/>
      <OperationButton operation="+" dispatch={dispatch}/>
      <DigitButton digit="7" dispatch={dispatch}/>
      <DigitButton digit="8" dispatch={dispatch}/>
      <DigitButton digit="9" dispatch={dispatch}/>
      <OperationButton operation="-" dispatch={dispatch}/>
      <DigitButton digit="" dispatch={dispatch}/>
      <DigitButton digit="0" dispatch={dispatch}/>
      <button className="span-two"  onClick={()=>dispatch({type:ACTIONS.EVALUATE})}>=</button>
    </div>
  );
}

export default App;
